import { globalAxiosInstance } from "../utils/axios";
import { makeRequest } from "../utils/makeRequest";
import { IoTKeyCommandType, IoTKeyCommandResponse} from "../../pages/IoTKeyCommands/iotKeyTypes";

export const useGetIoTKeyCommands = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/bridge_command_templates",
  axiosInstance: globalAxiosInstance,
  method: "get",
  withInitialLoading: true,
  transformResponse: (response: IoTKeyCommandResponse) => response?.data,
});

export const useGetIoTKeyCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: (data) => `/bridge_command_templates/${data.data}`,
  axiosInstance: globalAxiosInstance,
  method: "get",
  withInitialLoading: false,
  transformResponse: (response: IoTKeyCommandResponse) => response?.data,
});

export const useCreateIoTKeyCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/bridge_command_templates",
  buildData: (data) => data,
  axiosInstance: globalAxiosInstance,
  method: "post",
});

export const useUpdateIoTKeyCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: ({ data }) => `/bridge_command_templates/${data?.id}`,
  buildData: (data: IoTKeyCommandType) => data,
  axiosInstance: globalAxiosInstance,
  method: "put",
});

export const useDeleteIoTKeyCommand = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  axiosInstance: globalAxiosInstance,
  method: "delete",
  buildQuery: ({ data }) => `/bridge_command_templates/${data}`,
});
